// extracted by mini-css-extract-plugin
module.exports = {"skill":"skill__skill__nfv-O","logo":"skill__logo__6CIdW","name":"skill__name__1AaCO"};